import React from 'react';
import { useField } from 'react-final-form';

import { useDocumentColors } from '@wp-block-builder/stores/WaypointDocumentStore';

import RawColorPickerInput from '../raw/RawColorPickerInput';

type Props = {
  label: string;
  name: string;
  disableReset?: boolean;
};
export default function ColorInput({ label, name, disableReset }: Props) {
  const { input } = useField(name);
  const secondarySwatch = useDocumentColors();
  return (
    <RawColorPickerInput
      label={label}
      onChange={input.onChange}
      value={input.value}
      secondarySwatch={secondarySwatch}
      disableReset={disableReset}
    />
  );
}
